import { Component, OnInit } from '@angular/core';
import {GlobalDataService, IsAdmin, ResetAuthToken} from '../global-data.service';
import {Router} from '@angular/router';
import {AuthenticationService} from '../authentication-service.service';
import {ChangePasswordService} from '../change-password.service';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.css'],
  providers: [ChangePasswordService]
})
export class ChangePasswordComponent implements OnInit {

  private oldPass = '';
  private newPass = '';
  private confirmNewPass = '';
  private validationError = '';
  private actionMessage: string;
  private actionStatus = true;

  constructor(private globalDataService: GlobalDataService, private authService: AuthenticationService,
              private router: Router, private componentService: ChangePasswordService) { }

  ngOnInit() {
    this.authenticate();
  }

  authenticate(): void {
    if (this.globalDataService.token == null) {
      this.router.navigate(['/login']);
    } else {
      this.authService.Authenticate().then(this.main.bind(this))
        .catch(this.handleAuthenticationError.bind(this));
    }
  }

  handleAuthenticationError(e) {
    ResetAuthToken.call(this);
  }

  main(result): void {
  }

  onSubmit() {
    this.actionMessage = null;
    this.validationError = '';
    if (this.oldPass === '') {
      this.validationError = 'All fields are required.';
      return;
    }
    if (this.newPass === '') {
      this.validationError = 'All fields are required.';
      return;
    }
    if (this.confirmNewPass === '') {
      this.validationError = 'All fields are required.';
      return;
    }
    if (this.newPass !== this.confirmNewPass) {
      this.validationError = 'Passwords do not match';
      return;
    }
    if (this.newPass === this.oldPass) {
      this.validationError = 'New password must be different than old password';
      return;
    }
    this.componentService.resetPassword(this.oldPass, this.newPass).then(this.submitSuccess.bind(this))
      .catch(this.submitFail.bind(this));
  }

  submitFail(e) {
    if (e.status === 401) {
      ResetAuthToken.call(this);
    } else {
      this.actionStatus = false;
      this.actionMessage = 'Submit Failed!';
    }
  }

  submitSuccess(result = null) {
    this.actionStatus = true;
    this.actionMessage = 'Success!';
  }

}



// WEBPACK FOOTER //
// ./src/app/change-password/change-password.component.ts